import React from "react";
import { useStore } from "../../../helpers";
import { TabContext, TabList } from "@mui/lab";
import Tab from "@mui/material/Tab";
import { tabStyles } from "../../../new-features/service-requests/sr-settings/assignees/MUIstyles";

const AssignTaskTabs = () => {
  const {
    taskManagerStore: { active_assign_task_tab, setActiveAssignTaskTab },
  } = useStore();
  const classes = tabStyles();
  return (
    <div>
      <TabContext value={active_assign_task_tab}>
        <TabList
          // @ts-ignore
          indicatorColor="#B88EFE"
          variant={"fullWidth"}
          onChange={(e, value) => {
            setActiveAssignTaskTab(value);
          }}
          className={classes.tab}
        >
          {["Command", "UI"].map((tab) => (
            <Tab key={tab} label={tab} value={tab} />
          ))}
        </TabList>
      </TabContext>
    </div>
  );
};

export default AssignTaskTabs;
